import { Route, Switch, useLocation } from 'react-router-dom';
import { colorBackgroundBody } from '@spark/ui-components/theme';
import { paddingLeft } from '@spark/ui-components/theme';
import styled from 'styled-components';
import { useAuth } from '@/context/AuthContext';
import CognitoAuth from '@spark/ui-components/components/CognitoAuth';
import Layout from '../Layout/index';
import MainWrapper from './MainWrapper';
import DisponibilidadeMain from '../Disponibilidade/Listagem/index';
import DisponibilidadeFrotaPatio from '../DisponibilidadeFrotaPatio/index';
import DetalhesDisponibilidade from '../Disponibilidade/Detalhes/index';
import CadastrosDisponibilidadeMain from '../Disponibilidade/Cadastro/index';
import PrivateRoute from './PrivateRoute';
import NotFound from '../../containers/DefaultPage/404/index';
import ProtectedRoute from '@spark/ui-components/components/ProtectedRoute';
import ClientesMain from '../Clientes/Listagem/index';
import ClienteCadastro from '../Clientes/Cadastro/index';
import ClienteDetalhes from '../Clientes/Detalhes/index';

import OperacoesMain from '../Operacoes/Listagem/index';
import OperacaoCadastro from '../Operacoes/Cadastro/index';
import OperacaoDetalhes from '../Operacoes/Detalhes/index';
import PedidosMain from '../Pedidos/Listagem/index';
import PedidoCadastro from '../Pedidos/Cadastro/index';
import PedidoDetalhes from '../Pedidos/Detalhes/index';

import ViagensMain from '../Viagens/Listagem/index';
import ViagemCadastro from '../Viagens/Cadastro/index';
import ViagemDetalhes from '../Viagens/Detalhes/index';
import DepositoMain from '../Deposito/Listagem/index';
import DepositoCobrancasMain from '../Deposito/Cobrancas/index';
import DepositoEnderecamentoMain from '../Deposito/Enderecamento/index';
import DescargasMain from '../Descarga/Listagem/index';
import DescargaDetalhes from '../Descarga/Detalhes/index';
import DescargaDashboardMain from '../Descarga/Dashboard/index';
import DescargaJanelaMain from '../Descarga/Janela/index';
import DashboardMain from '../Dashboard';

import AcompanhamentosMain from '../Acompanhamentos/Listagem/index';
import AcompanhamentoCadastro from '../Acompanhamentos/Cadastro/index';
import AcompanhamentoDetalhes from '../Acompanhamentos/Detalhes/index';
import AcompanhamentoEditar from '../Acompanhamentos/Editar/index';
import NotificacoesMain from '../Notificacoes/index';

import ModelosMain from '../ModeloVeicular/Listagem/index';
import CadastrosModelosMain from '../ModeloVeicular/Cadastro/index';
import ModeloDetalhes from '../ModeloVeicular/Detalhes/index';

import VeiculosMain from '../Veiculos/Listagem/index';
import CadastrosVeiculoMain from '../Veiculos/Cadastro/index';
import VeiculoDetalhes from '../Veiculos/Detalhes/index';

import PlanejamentoDetalhadoMain from '../PlanejamentoDetalhado/Listagem/index';
import PlanejamentoDetalhadoSujestao from '../PlanejamentoDetalhado/SugestaoFrota/index';

import PrevisaoCargas from '../PrevisaoCargas/index';
import AcompanhamentoPublicoDeposito from '../Deposito/AcompanhamentoPublico/index';
import MotoristasMain from '../Motoristas/Listagem/index';
import MotoristaCadastro from '../Motoristas/Cadastro/index';
import MotoristaDetalhes from '../Motoristas/Detalhes/index';
import ProgramacaoHavanMain from '../ProgramacaoHavan/Listagem/index';
import EmissaoProtocoloMain from '../ProgramacaoHavan/Protocolos/index';
// Nova Tela Containers - Depots
import DepotsMain from '../Containers/Listagem/index';
import DetalhesDepots from '../Containers/Detalhes/index';
import CadastrosDepotsMain from '../Containers/Cadastro/index';
import AnexosMain from '../Anexos/Listagem'

const Pages = () => <Switch>
  {
    /* Rotas de Clientes - Movidas para o topo para evitar conflitos */
  }
  <ProtectedRoute path="/pages/clientes/detalhes/:id" component={ClienteDetalhes} />
  <ProtectedRoute path="/pages/clientes/cadastro" component={ClienteCadastro} />
  <ProtectedRoute path="/pages/clientes/criar" component={ClienteCadastro} />
  <ProtectedRoute path="/pages/clientes/editar/:id" component={ClienteCadastro} />
  <ProtectedRoute exact path="/pages/clientes" component={ClientesMain} />

  {
    /* Rotas de Disponibilidade */
  }
  <ProtectedRoute exact path="/pages/programacao/disponibilidadeFrotaPatio" component={DisponibilidadeFrotaPatio} />
  <ProtectedRoute path="/pages/programacao/disponibilidade" component={DisponibilidadeMain} // requiredRights={['frotas.visualizar']}
  />
  <ProtectedRoute path="/pages/programacao/criar" component={CadastrosDisponibilidadeMain} // requiredRights={['frotas.criar']}
  />
  <ProtectedRoute path="/pages/programacao/criardisponibilidade" component={CadastrosDisponibilidadeMain} // requiredRights={['frotas.criar']}
  />
  <Route path="/pages/programacao/detalhesdisponibilidade/personalizado/:id" component={DetalhesDisponibilidade} />
  <Route path="/pages/programacao/detalhesdisponibilidade/:id" component={DetalhesDisponibilidade} />
  <ProtectedRoute exact path="/pages/programacao/havan" component={ProgramacaoHavanMain} />
  <ProtectedRoute exact path="/pages/programacao/havan/protocolos" component={EmissaoProtocoloMain} />








  {
    /* Rotas de Modelos */
  }
  <ProtectedRoute path="/pages/modelos/modelos" component={ModelosMain} />
  <ProtectedRoute path="/pages/modelo/modelo/criar" component={CadastrosModelosMain} />
  <ProtectedRoute path="/pages/modelo/detalhes/:id" component={ModeloDetalhes} />
  <ProtectedRoute path="/pages/modelo/editar/:id" component={CadastrosModelosMain} />

  {
    /* Rotas de Veiculos */
  }
  <ProtectedRoute path="/pages/veiculos/detalhes/:id" component={VeiculoDetalhes} />
  <ProtectedRoute path="/pages/veiculos/editar/:id" component={CadastrosVeiculoMain} />
  <ProtectedRoute path="/pages/veiculos/criar" component={CadastrosVeiculoMain} />
  <ProtectedRoute exact path="/pages/veiculos" component={VeiculosMain} />

  {
    /* Rotas de Operações */
  }
  <ProtectedRoute exact path="/pages/operacoes" component={OperacoesMain} />
  <ProtectedRoute path="/pages/operacoes/criar" component={OperacaoCadastro} />
  <ProtectedRoute path="/pages/operacoes/editar/:id" component={OperacaoCadastro} />
  <ProtectedRoute path="/pages/operacoes/detalhes/:id" component={OperacaoDetalhes} />

  {
    /* Rotas de Viagens */
  }
  <ProtectedRoute path="/pages/viagens/detalhes/:id" component={ViagemDetalhes} // requiredRights={['viagens.visualizar']}
  />
  <ProtectedRoute path="/pages/viagens/editar/:id" component={ViagemCadastro} // requiredRights={['viagens.editar']}
  />
  <ProtectedRoute path="/pages/viagens/criar" component={ViagemCadastro} // requiredRights={['viagens.criar']}
  />
  <ProtectedRoute exact path="/pages/viagens" component={ViagensMain} // requiredRights={['viagens.listar']}
  />



  {
    /* Rotas de Pedidos */
  }
  <ProtectedRoute exact path="/pages/pedidos" component={PedidosMain} />
  <ProtectedRoute path="/pages/pedidos/criar" component={PedidoCadastro} // requiredRights={['pedidos.criar']}
  />
  <ProtectedRoute path="/pages/pedidos/editar/:id" component={PedidoCadastro} // requiredRights={['pedidos.editar']}
  />
  <ProtectedRoute path="/pages/pedidos/detalhes/:id" component={PedidoDetalhes} // requiredRights={['pedidos.visualizar']}
  />

  {
    /* Rotas de Planejamento detalhado */
  }
  <ProtectedRoute exact path="/pages/planejamentodetalhado" component={PlanejamentoDetalhadoMain} />
  <ProtectedRoute path="/pages/planejamentodetalhado/sugestao/:id" component={PlanejamentoDetalhadoSujestao} />

  {
    /* Rotas de Deposito */
  }
  <ProtectedRoute exact path="/pages/deposito" component={DepositoMain} />
  <ProtectedRoute exact path="/pages/cobrancas-deposito" component={DepositoCobrancasMain} />
  <ProtectedRoute exact path="/pages/enderecamento" component={DepositoEnderecamentoMain} />

  {
    /* Rotas de Descarga */
  }
  <ProtectedRoute exact path="/pages/descarga" component={DescargasMain} />
  <ProtectedRoute exact path="/pages/descarga/dashboard" component={DescargaDashboardMain} />
  <ProtectedRoute exact path="/pages/descarga/descargas" component={DescargasMain} />
  <ProtectedRoute exact path="/pages/descarga/descargas/detalhes" component={DescargaDetalhes} />
  <ProtectedRoute exact path="/pages/descarga/janela" component={DescargaJanelaMain} />

  {
    /* Rotas de Dashboard */
  }
  <ProtectedRoute path="/pages/dashboard" component={DashboardMain} />

  {
    /* Rotas de Acompanhamentos */
  }
  <ProtectedRoute exact path="/pages/acompanhamentos" component={AcompanhamentosMain} // requiredRights={['acompanhamentos.listar']}
  />
  <ProtectedRoute path="/pages/acompanhamentos/criar" component={AcompanhamentoCadastro} // requiredRights={['acompanhamentos.criar']}
  />
  <ProtectedRoute path="/pages/acompanhamentos/editar/:id" component={AcompanhamentoEditar} // requiredRights={['acompanhamentos.editar']}
  />
  <ProtectedRoute path="/pages/acompanhamentos/detalhes/:id" component={AcompanhamentoDetalhes} // requiredRights={['acompanhamentos.visualizar']}
  />

  {
    /* Rotas de Notificações */
  }
  <ProtectedRoute exact path="/pages/notificacoes" component={NotificacoesMain} />
  {
    /* Se quiser detalhes de notificação, adicione aqui: */
  }
  {
    /* <ProtectedRoute 
     path="/pages/notificacoes/detalhes/:id" 
     component={NotificacaoDetalhes}
    /> */
  }

  {
    /* Rotas de Previsão de Cargas */
  }
  <ProtectedRoute exact path="/pages/previsao-cargas" component={PrevisaoCargas} />

  {
    /* Rotas de Depots */
  }
  <Route path="/pages/containers/programacao/detalhesdepots/personalizado/:id" component={DetalhesDepots}/>
  <Route path="/pages/containers/programacao/detalhesdepots/:id" component={DetalhesDepots}/>
  <ProtectedRoute path="/pages/containers/programacao/editar/:id" component={CadastrosDepotsMain}/>
  <ProtectedRoute path="/pages/containers/programacao/criar" component={CadastrosDepotsMain}/>
  <ProtectedRoute exact path="/pages/containers/programacao" component={DepotsMain}/>
  <ProtectedRoute exact path="/pages/containers/anexos" component={AnexosMain} />
  {
    /* Rotas de Motoristas */
  }
  <ProtectedRoute path="/pages/motoristas/detalhes/:id" component={MotoristaDetalhes} />
  <ProtectedRoute path="/pages/motoristas/edicao/:id" component={MotoristaCadastro} />
  <ProtectedRoute path="/pages/motoristas/cadastro" component={MotoristaCadastro} />
  <ProtectedRoute exact path="/pages/motoristas" component={MotoristasMain} />

  <Route component={NotFound} />
</Switch>;

const WrappedRoutes = () => {
  const location = useLocation();
  const { loading } = useAuth();
  const isPersonalizado = location.pathname.includes('/detalhesdisponibilidade/personalizado/');

  // Se ainda está carregando, mostra loading
  if (loading) {
    return <div>Carregando...</div>;
  }

  const Container = isPersonalizado ? ContainerFullPage : ContainerWithLayout;
  return (
    <div>
      {!isPersonalizado && <Layout />}
      <Container>
        <Pages />
      </Container>
    </div>
  );
};

const Router = () => {
  return (
    <MainWrapper>
      <main>
        <Switch>
          <Route exact path={['/', '/log_in']} component={CognitoAuth} />
          <Route path="/acompanhamento-deposito" component={AcompanhamentoPublicoDeposito} />
          <PrivateRoute path="/pages" component={WrappedRoutes} />
          <Route component={NotFound} />
        </Switch>
      </main>
    </MainWrapper>
  );
};

export default Router; // region STYLES

const ContainerWithLayout = styled.div`
  padding-top: 90px;
  min-height: 100vh;
  transition: padding-left 0.3s;
  background: ${colorBackgroundBody};
  ${paddingLeft}: 0;

  @media screen and (min-width: 576px) {
    ${paddingLeft}: 250px;
  }

  @media screen and (max-width: 576px) {
    padding-top: 70px;
  }
`;
const ContainerFullPage = styled.div`
  padding: 0;
  min-height: 100vh;
  background: ${colorBackgroundBody};
`; // endregion
